import { data_from_server_post } from '@/shared/http/client';

const noop = () => {};

/**
 * HTTP wrappers for the Spark wizard assistant (`backend/app/routes/assistant_route.py`).
 *
 * `chat` / `escalate` reject on transport or HTTP failure so the hook can show
 * a short error bubble. `setWizardAssistantDismissed` still writes the old
 * preference; the wizard no longer calls it.
 */

/** Wrap a `data_from_server_post` call into a Promise that rejects on failure. */
function postJson(suffix, payload) {
    return new Promise((resolve, reject) => {
        try {
            data_from_server_post(
                suffix,
                payload,
                (result) => resolve(result),
                (detail, err) => reject(err || new Error(detail || `${suffix} failed`))
            ).catch(noop);
        } catch (err) {
            reject(err);
        }
    });
}

/**
 * One assistant turn (`POST /assistant/chat`).
 * @param {object} payload `AssistantChatRequest` — messages, wizard_state,
 *   pending_question, pending_context, event, selected_option.
 * @returns {Promise<object>} `AssistantTurnResponse`
 */
export function chat(payload) {
    return postJson('assistant/chat', payload);
}

/**
 * Email the transcript to support (`POST /assistant/escalate`).
 * @param {object} payload `AssistantEscalateRequest` — messages, usecase_id, step.
 * @returns {Promise<{success: boolean, message: string}>}
 */
export function escalate(payload) {
    return postJson('assistant/escalate', payload);
}

/**
 * Persist that the user closed the panel (`preferences.wizard_assistant_dismissed`).
 * Resolves with the merged `preferences` or `null`; never rejects.
 */
export function setWizardAssistantDismissed(dismissed) {
    return new Promise((resolve) => {
        try {
            data_from_server_post(
                'users/set-preferences',
                { wizard_assistant_dismissed: Boolean(dismissed) },
                (result) => resolve(result?.preferences || null),
                () => resolve(null)
            ).catch(noop);
        } catch {
            resolve(null);
        }
    });
}
